import script from "./QwBaseButton.vue?vue&type=script&lang=js"
export * from "./QwBaseButton.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__